import CFSLogo from '../assets/afl-logo.png'
import spinnerloading from '../assets/line.gif'
import PSLogo from '../assets/PeranaSportsSquare512.png'

function Spinner({message}) {
  return (
    <div className='w-100 p-4 bg-base-100'>
      <img
        width={180}
        className='text-center mx-auto'
        src={PSLogo}
        alt='CFS'
      />
      <img
        width={180}
        className='text-center mx-auto'
        src={CFSLogo}
        alt='CFS'
      />
      <h3 className='text-2xl text-center text-base-content font-bold'>
        AFL StatTracker
      </h3>
      <img
        width={180}
        className='text-center mx-auto my-4'
        src={spinnerloading}
        alt='Loading...'
      />
      <p className='text-base-content text-center'>{message}</p>
    </div>
  )
}

export default Spinner
